export const defaultConfig = {
  cookies: {
    currencyCookieName: 'vsf-currency',
    countryCookieName: 'vsf-country',
    localeCookieName: 'vsf-locale',
    cartCookieName: 'vsf-cart',
    customerCookieName: 'vsf-customer',
    storeCookieName: 'vsf-store',
    messageCookieName: 'vsf-message',
    cookieConsentName: 'vsf-cookie-consent',
  },
  locale: undefined as undefined,
  country: undefined as undefined,
  currency: undefined as undefined,
} as const;
